import { render, staticRenderFns } from "./PopupLogReset.vue?vue&type=template&id=8b25f08e&scoped=true&"
import script from "./PopupLogReset.vue?vue&type=script&lang=js&"
export * from "./PopupLogReset.vue?vue&type=script&lang=js&"
import style0 from "./PopupLogReset.vue?vue&type=style&index=0&id=8b25f08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b25f08e",
  null
  
)

export default component.exports